import React from "react";

import addedStatusIcon from "../../../../../../assets/images/product/specmanager/checkbox-circle-line.svg";
import pendingIcon from "../../../../../../assets/images/product/specmanager/circle-line.svg";

import "./GlobalSpecTable.css";

const LABEL_ADDED = "Spec Added";
const LABEL_PENDING = "Incomplete";

/**
 * Shared “Spec Added” / “Incomplete” chip for global test spec list, overview, and edit preview.
 * Styling lives in GlobalSpecTable.css (BEM: GlobalSpecTable__StatusChip*).
 */
const TestSpecStatusChip = ({
  status,
  id,
  className = "",
  addedIconId,
  pendingIconId,
  ariaLabel,
}) => {
  const isAdded = status === "added";
  const modifier = isAdded
    ? "GlobalSpecTable__StatusChip--added"
    : "GlobalSpecTable__StatusChip--pending";

  return (
    <div
      className={`GlobalSpecTable__StatusChip ${modifier}${className ? ` ${className}` : ""}`.trim()}
      id={id}
      aria-label={ariaLabel}
    >
      {isAdded ? (
        <img
          className="GlobalSpecTable__SpecAddedIcon"
          src={addedStatusIcon}
          alt="addedIcon"
          id={addedIconId}
        />
      ) : (
        <img
          src={pendingIcon}
          alt="pendingIcon"
          className="GlobalSpecTable__PendingIcon"
          id={pendingIconId}
        />
      )}
      {isAdded ? LABEL_ADDED : LABEL_PENDING}
    </div>
  );
};

export default TestSpecStatusChip;
